// extracted by mini-css-extract-plugin
export default {"productsContainer":"TMZjn","product":"x12nZ","productsList":"nbdEu"};